<template>
  <div>



    <b-container fluid v-if="taskData">
      <b-row class="mb-3">
        <b-col cols="12">
          <PageHeader
            :title="$cte('tasks.task')"
            :special-back-link="true"
            :enable-back-link="true"
            @goBack="returnToTasks"
          />
        </b-col>
      </b-row>
      <b-row class="font-jumper">
        <b-col cols="12" class="bg-white mb-4 text-center" style="border-radius: 24px;">

          <div class=" mx-auto bg-white notificationContentContainer" v-if="taskData">
            <div class="text-muted text-center">{{ formatDate(taskData.createdOn) }}</div>
            <div v-html="taskData.content" class="notificationContent"></div>
          </div>


        </b-col>
        <b-col>


          <b-card bg-variant="white" style="margin-left: -15px; margin-right: -15px;">
            <template v-slot:header>
              <b-container fluid>
                <b-row v-if="taskData" class="mb-4">
                  <b-col cols="12">
                    <b-row>
                      <b-card
                        v-if="
                          taskData.attachments && taskData.attachments.length > 0
                        "
                        :sub-title="$cte('common.attachments')"
                      >
                        <b-row class="ml-1">
                          <div
                            v-for="(item, index) in taskData.attachments"
                            class="custom-thumbnail mr-2"
                            @click="fileClick(item)"
                            :title="item.name"
                            :key="index"
                          >

                            <div
                              class="custom-file-icon"
                              :title="item.attachmentName"
                            >
                              <h1 class="file-icon file">
                                <i class="far fa-file-alt"></i>
                              </h1>
                            </div>
                            <div>
                              <small
                                class="nowrap file-text file-label-hack"
                              >
                                {{ item.attachmentName }}
                              </small>
                            </div>
                          </div>
                        </b-row>
                      </b-card>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <b-row class="bottom-buttons">
                      <b-col
                        cols="12"
                        :md="getMdColSize"
                        class="mb-2"
                      >
                      </b-col>
                      <b-col cols="12" :md="getMdColSize" class="mb-2" v-if="taskData?.status !== 'DONE'">
                        <div
                          :class="{
                            second: getMdColSize === 4,
                            first: getMdColSize === 6,
                          }"
                          class="max-content"
                        >
                          <b-button
                              variant="primary"
                              @click="() => setStatus('DONE')"
                              class="mx-2"
                          >
                            {{ $cte("tasks.done") }}
                          </b-button>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-container>
            </template>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <div v-else>
      betöltés...
    </div>

    <b-modal
      class="p-0 m-0"
      centered
      hide-footer
      v-if="selectedFile"
      :ok-title="$cte('common.ok')"
      size="md"
      @ok="handleOk"
      id="modal-scrollable"
      v-model="displayModal"
      :title="selectedFile.name"
    >
      <b-overlay :show="modalLoading" rounded="sm">
        <b-row class="w-100 m-0 p-0">
          <div class="mx-auto">
            <h1 class="h-100 w-100 mx-auto display-3">
              <i class="far fa-file-alt"></i>
            </h1>
          </div>
        </b-row>
        <b-row class="justify-content-center">
          <p>{{ selectedFile.attachmentName }}</p>
        </b-row>

        <b-row class="justify-content-center mt-3">
          <b-button
            variant="success"
            class="px-3 py-2 mr-2"
            @click="fileDownload"
          >
            <i class="fas fa-file-download"></i> {{ $cte("common.download") }}
          </b-button>

          <b-button
            variant="secondary"
            class="px-3 py-2"
            @click="selectedFile = null"
          >
            {{ $cte("common.ok") }}
          </b-button>
        </b-row>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader";
import Api from "api-client";
import { mapGetters } from "vuex";
import moment from "moment";
import 'moment/locale/hu';

export default {
  name: "Task",
  components: {
    PageHeader,
  },
  data() {
    return {
      selectedFile: null,
      modalLoading: false,
      displayModal: false,
      taskData: undefined,
      backRouterLink: "",
      pageNumber: null,
      perPage: null,
      taskId: null,
    };
  },
  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
    getMdColSize() {
      if (
        this.taskData &&
        this.taskData.statusId === 904
      ) {
        return 6;
      } else {
        return 4;
      }
    },
  },
  methods: {
    formatDate(timestamp) {
      const date = moment(timestamp);
      return date.format('YYYY.MM.DD. HH:mm');
    },
    resizeIframe() {
      this.$refs.iframe.style.height = (this.$refs.iframe.contentWindow.document.body.scrollHeight + 30) + 'px';
    },
    fileDownload() {
      this.modalLoading = true;
      this.downloadFile(this.selectedFile);
    },

    downloadFile(file) {
      let self = this;
      Api.fileDownloadNEW(file.id)
        .then((resp) => {
          this.forceFileDownload(resp, file);
          self.$toast.success({
            title: self.$cte("toast.download-success"),
            message: self.$cte("document.downloadSucceed"),
          });
        })
        .catch(() => {
          self.$toast.error({
            title: self.$cte("toast.download-failed"),
            message: self.$cte("document.downloadFailed"),
          });
        })
        .finally(() => {
          self.modalLoading = false;
        });
    },

    forceFileDownload(response, item) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      if (response.headers["content-type"] === "application/zip") {
        link.setAttribute("download", item.name + ".zip"); //or any other extension
      } else {
        link.setAttribute("download", item.attachmentName); //or any other extension
      }
      document.body.appendChild(link);
      link.click();
    },

    handleOk() {
      this.selectedFile = null;
      this.displayModal = false;
    },

    fileClick(item) {
      this.selectedFile = item;
      this.displayModal = true;
    },

    getUrlData() {
      this.backRouterLink = this.$route.query.backRouterLink;
      this.pageNumber = this.$route.query.pageNumber;
      this.perPage = this.$route.query.perPage;
      this.taskId = this.$route.query.id;
    },

    getData() {
      let self = this;
      Api.getTaskById(self.taskId)
        .then((resp) => {
          self.taskData = resp.data;
          if (self.taskData.status === 'UNREAD') {
            
            this.setStatus('READ');
          }
        })
        .catch(() => {
          self.$toast.error({
            title: this.$cte("common.error"),
            message: this.$cte("tasks.failedGetTask"),
          });
        });
    },

    setStatus(status) {
      Api.setTaskStatus(this.taskId, status)
        .then(() => {
          if (status === 'DONE') {
            this.returnToTasks();
          }
        })
        .catch(() => {
          this.$toast.error({
            title: 'Hiba',
            message: 'Hiba',
          });
        });
    },

    returnToTasks() {
      let self = this;
      if (self.backRouterLink) {
        if (self.pageNumber) {
          self.$router.push({
            path: self.backRouterLink,
            query: {
              pageNumber: self.pageNumber,
              perPage: self.perPage,
            },
          });
        } else {
          self.$router.push(self.backRouterLink);
        }
      } else {
        self.$router.push("/app/home");
      }
    },

    messengerClick() {
      let url = "//messenger.com/t/acountoapp";
      window.open(url, "_blank");
    },
  },
  created() {
    this.getUrlData();
    this.getData();
  },
};
</script>

<style scoped>

@media (min-width: 768px) {
  .bottom-buttons .first {
    float: left;
  }

  .bottom-buttons .second {
    margin: 0 auto;
  }

  .bottom-buttons .third {
    float: right;
  }
}

.bottom-buttons .btn {
  width: 125px !important;
}

.bottom-buttons > div > div {
  margin: 0 auto;
}

.max-content {
  width: max-content;
}

.bottom-buttons .btn {
  color: white;
}

.custom-thumbnail {
  cursor: pointer;
  max-width: 128px;
  max-height: 128px;
  height: 128px;
  min-width: 72px;
  background-color: #eee;
  border-radius: 5px;
  position: relative;
  border: 1px solid gray;
}

.custom-image-preview {
  max-height: 128px;
  max-width: 128px;
  width: 100%;
  height: 100%;
}

.file-label-hack {
  position: absolute;
  bottom: -19px;
}

.file-text {
  display: block;
  width: 70px;
}

.custom-thumbnail-image {
  border-radius: 5px;
}

.nowrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.custom-file-icon {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 30px;
  height: 45px;
}

.notificationContent {
  width: 600px;
  margin-left: auto;
  margin-right: auto;
}

@media (max-width: 768px) {
  .notificationContentContainer {

  }
  .notificationContent {
    zoom: 0.5;
    padding-left: 10px;
  }
}

</style>
